var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import SImageCompressor from "../SImageCompressor";
var Upload = /** @class */ (function () {
    function Upload() {
    }
    Upload.send = function (file, url) {
        if (!file)
            return;
        console.log(file.file);
        var body = new FormData();
        body.append('file', file.file);
        var request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.send(body);
        console.log("Se envio la data");
    };
    Upload.sendPromise = function (_a, url) {
        var _this = this;
        var file = _a.file;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var body, request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!file)
                            reject("file not found");
                        if (!file.type)
                            reject("file.type not found");
                        if (!file.type.startsWith("image")) return [3 /*break*/, 2];
                        return [4 /*yield*/, SImageCompressor.compress({ file: file, maxWidth: 1024, quality: 0.8 })];
                    case 1:
                        file = _a.sent();
                        _a.label = 2;
                    case 2:
                        console.log("enviandoooooo");
                        body = new FormData();
                        body.append('file', file);
                        request = new XMLHttpRequest();
                        request.open('POST', url, true);
                        request.onload = function () {
                            if (this.status >= 200 && this.status < 300) {
                                resolve(request.response);
                            }
                            else {
                                reject({
                                    status: this.status,
                                    statusText: request.statusText,
                                    "in": "onload"
                                });
                            }
                        };
                        request.onerror = function () {
                            reject({
                                status: this.status,
                                statusText: request.statusText,
                                "in": "onerror"
                            });
                        };
                        request.send(body);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    return Upload;
}());
export default Upload;
